export default "__VITE_ASSET__BPTWDv4N__"